export default __webpack_public_path__ + "static/media/BCI_VR.761047b8.webp";